import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {take} from 'rxjs/operators';
import {AppComponent} from '../app.component';
import {Estimation} from '../Models/Estimation';
import {cloneDeep} from "lodash";
import {saveAs} from "file-saver";
import {EtatEstimation} from "../Models/EtatEstimation";
import {ROUTES_PATHS} from "../const/routes";
import {RENOVATION_MAP, RenovationKey} from "../const/renovation-type";
import {TableBoName} from "../enums/table-bo-name.enum";
import { getEstimationFromId } from '../helpers/estimation.helper';

@Component({
	selector: 'app-estimations',
	templateUrl: './estimations.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./estimations.component.less']
})

export class EstimationsComponent implements OnInit {
	globalTxt: any;
	textes: any;
	modalsTxt: any;
	userId: any = JSON.parse(localStorage.getItem("user_id")!);
	token: any = JSON.parse(localStorage.getItem("token")!);
	searchTerm: string = '';
	estimations: Estimation[] = [];
	originalEstimations: Estimation[] = [];
	tabOptions: any = this.app.sharedToolsService.initTabOptions(TableBoName.ESTIMATIONS);
	etatsEstimations: EtatEstimation[] = [];

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		if (parseInt(this.token.simuUsed) == 0 && parseInt(this.token.simuTotal) == 0) {
			this.app.router.navigate(['/' + ROUTES_PATHS.PRODUITS]);
			return;
		}

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		// Get the simulations by user ID
		this.getAllSimulationByUsrId(this.userId);

		// Get the texts
		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;

					// Get the modal texts
					this.app.dataInitService.getModalTextsOnce(modalsTxt => {
						this.modalsTxt = modalsTxt;
					});

					// Set the previous and next labels for pagination
					this.app.previousLabelTxt = this.app.sharedToolsService.getPaginationLabels('prev');
					this.app.nextLabelTxt = this.app.sharedToolsService.getPaginationLabels('next');

					// Get all the states of the estimations
					this.getAllDataRefEts();
				})
			})
	}

	getAllDataRefEts() {
		this.app.apiToolsService.getAllDataRef('ETS').subscribe(
			(resData: any) => {
				console.log("getAllDataRefEts data ==> ", resData);
				this.etatsEstimations = resData.Data;
			});
	}

	getAllSimulationByUsrId(_userId: any) {
		this.app.apiToolsService.getAllSimulationByUsrId(_userId).subscribe((data: any) => {
			console.log("getAllSimulationByUsrId data ==> ", data);
			let estimations: Estimation[] = [];
			estimations = cloneDeep(data);

			// Format the address
			estimations.forEach((estimation: any) => {
				let address = estimation.SIN_ASSURE_ADRESSE_1 || '';
				let postal_code = estimation.SIN_ASSURE_CP || '';
				let city = estimation.SIN_ASSURE_VILLE || '';
				let country = estimation.SIN_ASSURE_PAYS || '';
				estimation.SIN_ADRESSE_FULL = address + " " + postal_code + " " + city + " " + country;
				estimation.ETS_ID = (estimation.SIN_MNT_TOTAL_HT) ? 3 : 2;
				estimation.SIN_MNT_TOTAL_HT = (estimation.SIN_MNT_TOTAL_HT) ? estimation.SIN_MNT_TOTAL_HT : 0;
				estimation.SIN_MNT_TOTAL_HT = new Intl.NumberFormat('fr-FR', {
					style: 'currency',
					currency: 'EUR'
				}).format(estimation.SIN_MNT_TOTAL_HT);
			});
			this.estimations = estimations;
			this.originalEstimations = estimations;

			// Sort the table by descending ID by default
			this.app.sharedToolsService.sortTable(this.tabOptions.sortKey, this.estimations, this.tabOptions);
		});
	}

	search() {
		if (this.searchTerm) {
			this.estimations = this.app.sharedToolsService.searchInTable(this.searchTerm, this.originalEstimations, this.etatsEstimations, this.textes.blocTable.cols);
		} else {
			this.estimations = [...this.originalEstimations];
		}
		this.tabOptions = this.app.sharedToolsService.initTabOptions(TableBoName.ESTIMATIONS);
	}

	addEstimation() {
		console.log("addEstimation");
		//console.log("token ==> ", this.token);

		if (!this.token) return;

		if (parseInt(this.token.simuUsed) >= parseInt(this.token.simuTotal)) {
			this.app.router.navigate(['/' + ROUTES_PATHS.PRODUITS]);
			return;
		}

		this.app.router.navigate([ROUTES_PATHS.WELCOME]);
	}

	// editEstimation(_id: number) {
	// 	console.log("editEstimation ==> ", _id);
	//
	// 	this.app.apiToolsService.getBatimentSimulation(_id).subscribe((data: any) => {
	// 			console.log("getBatimentSimulation data ==> ", data);
	//
	// 			if (data) {
	// 				localStorage.setItem("BATIMENT", JSON.stringify(data));
	//
	// 				const renovationKey: RenovationKey = data.renovation as RenovationKey;
	// 				let renovation: string = RENOVATION_MAP[renovationKey] ?? "";
	// 				console.log("renovation → ", renovation)
	//
	// 				if (renovation == "") {
	// 					console.warn("renovation:", renovation);
	// 					return;
	// 				}
	//
	// 				localStorage.setItem("RENOVATION", renovation);
	//
	// 				this.app.apiToolsService.getSinistreByID(parseInt(data.simulationId!), true).subscribe(res => {
	// 					console.log("res getSinistreByID ==> ", res);
	//
	// 					let arrPieces: any = [];
	// 					arrPieces = cloneDeep(res);
	//
	// 					if (!Array.isArray(arrPieces) || arrPieces.length == 0) {
	// 						console.warn("arrPieces:", renovation);
	// 						return;
	// 					}
	//
	// 					localStorage.setItem("arrPieces", JSON.stringify(arrPieces));
	//
	// 					setTimeout(() => {
	// 						this.app.router.navigate([ROUTES_PATHS.ESTIMATION_RAPIDE]);
	// 					}, 100);
	// 				});
	// 			}
	// 		}, err => {
	// 			this.app.confirmDialogService.confirmThis(
	// 				'', this.modalsTxt.modalErrorApi, 'alert', '',
	// 				() => {
	// 				}, () => {
	// 				});
	// 			console.log('ERR getBatimentSimulation ==> ', err);
	// 		}
	// 	);
	// }

	editEstimation(_id:number) {
		getEstimationFromId(_id, this.app.apiToolsService).pipe(take(1))
			.subscribe({
				next: () => {
					// On a stocké BATIMENT / RENOVATION / arrPieces -> navigue proprement
					// Vérification des pièces avant la navigation
					const arrPieces = JSON.parse(localStorage.getItem('arrPieces') || '[]');
					if (!Array.isArray(arrPieces) || arrPieces.length === 0) {
						console.warn("arrPieces empty", arrPieces);
						return;
					}
					setTimeout(() => {
						this.app.router.navigate([ROUTES_PATHS.ESTIMATION_RAPIDE]);
					}, 100);
				},
				error: (err) => {
					// Gérer l'erreur (afficher modal)
					this.app.confirmDialogService.confirmThis('', this.modalsTxt.modalErrorApi, 'alert', '', () => {}, () => {});
					console.error('Erreur chargement estimation', err);
				}
			});
	}

	sendEstimation(_id: number) {
		console.log("sendEstimation ==> ", _id);
		// Call API
		this.app.apiToolsService.sendMailPdf(_id).subscribe((data: any) => {
				console.log("sendMailPdf data ==> ", data);
				if (data) {
					this.app.confirmDialogService.confirmThis(
						'', this.modalsTxt.modalMailSended,
						'alert', '', () => {
						}, () => {
						});
				}
			}, err => {
				this.app.confirmDialogService.confirmThis(
					'', this.modalsTxt.modalErrorApi, 'alert', '',
					() => {
					}, () => {
					});
				console.log('ERR sendEstimation ==> ', err);
			}
		);
	}

	downloadEstimation(_id: number) {
		console.log("downloadEstimation ==> ", _id);
		// Call API
		this.app.apiToolsService.generatePdf(_id).subscribe(
			(res) => {
				console.log("generatePdf res ==> ", res);
				if (res) {
					// Call API Download .pdf
					let blob = new Blob([res], {type: "application/pdf;charset=utf-8"});
					saveAs(blob, "Estimation_" + _id + ".pdf");
				}
			},
			(err) => {
				console.error("ERR downloadEstimation ==> ", err);
				this.app.confirmDialogService.confirmThis(
					'', this.modalsTxt.modalErrorApi, 'alert', '', () => {
					}, () => {
					});
			});
	}

	deleteEstimation(_id: number) {
		this.app.confirmDialogService.confirmThis(
			"", this.modalsTxt.modalSupp, //text
			"confirm", //type
			"suppression", //template
			() => {
				// Call API Delete Simulation
				this.app.apiToolsService.deleteSimulationById(_id).subscribe(
					(data: any) => {
						console.log("deleteSimulation data ==> ", data);
						if (!data) {
							this.app.confirmDialogService.confirmThis(
								'',
								this.modalsTxt.modalSuccessDeleteSimulation,
								'alert', '',
								() => {
									this.searchTerm = '';
									this.getAllSimulationByUsrId(this.userId);
								},
								() => {
								});

						}
					},
					err => {
						console.error("ERR deleteEstimation ==> ", err);
						this.app.confirmDialogService.confirmThis(
							'', this.modalsTxt.modalErrorApi, 'alert', '', () => {
							}, () => {
							});
					}
				);
			},
			() => {
			});
	}
}
